import { render, staticRenderFns } from "./ConversatiionSkeleonHeader.vue?vue&type=template&id=37888297&scoped=true&"
var script = {}
import style0 from "./ConversatiionSkeleonHeader.vue?vue&type=style&index=0&id=37888297&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37888297",
  null
  
)

export default component.exports